import React from "react";
import styles from "./loader.module.scss";
import { Loader as NorthstarLoader } from "@fluentui/react-northstar";
import { LoaderProps } from "./Loader.types";

const Loader: React.FC<LoaderProps> = (props: LoaderProps) => {
  return (
    <div className={styles.wrapper}>
      <NorthstarLoader title={props.text} label={props.text} />
    </div>
  );
};

export default Loader;
